import type { RouteRecordRaw } from 'vue-router'

// Home 模块子页 + 活动页 + 添加设备引导
export const homeRoutes: RouteRecordRaw[] = [
  {
    path: '/home/switch-device',
    name: 'home-switch-device',
    component: () => import('@/pages/Home/SwitchDevice/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/map',
    name: 'home-map',
    component: () => import('@/pages/Home/Map/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/device-manage',
    name: 'home-device-manage',
    component: () => import('@/pages/Home/DeviceManage/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/chat/:subUserId',
    name: 'chat',
    component: () => import('@/pages/Home/Chat/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/device-manage/switch-sub-account',
    name: 'home-device-manage-switch-sub-account',
    component: () => import('@/pages/Home/DeviceManage/SwitchSubAccount/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/habit-manage',
    name: 'home-habit-manage',
    component: () => import('@/pages/Home/HabitManage/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/traffic-zone',
    name: 'home-traffic-zone',
    component: () => import('@/pages/Home/TrafficZone/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    path: '/home/traffic-zone/redeem-code',
    name: 'home-traffic-zone-redeem-code',
    component: () => import('@/pages/Home/TrafficZone/RedeemCode/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 活动页
    path: '/home/activity',
    name: 'home-activity',
    component: () => import('@/pages/Home/ActivetyPage/index.vue'),
    meta: { backMode: 'allow' },
  },
  {
    // 添加设备引导（Home 设备接口返回 2033 时跳转）
    path: '/guide',
    name: 'guide',
    component: () => import('@/pages/Guide/index.vue'),
    meta: { backMode: 'exit' },
  },
]
